import React, { useRef } from 'react';
import { useCalendar } from '../calendarContext';
import WeekNavigation from '../week/weekNavigation';
import BookItOrCreate from '../bookItOrCreate';
import EventScheduler from '../day/eventScheduler';

const DayView = ({ currentDate, bookingData, showShortWeekCalendar = true, showTimeSlots = true }) => {
  const { selectedDate, myBookingTypes, bookingDatas } = useCalendar();

  const dataToProcess = Array.isArray(bookingData) ? bookingData : bookingData ? [bookingData] : bookingDatas;
  const bookItOrCreateRef = useRef(null);
  const desiredDate = currentDate || selectedDate
  const getEventsForHour = (hour) => {
    const formattedDate = desiredDate.toISOString().slice(0, 10); // "YYYY-MM-DD"

    // Define the time range for this hour slot
    const startOfHour = new Date(desiredDate);
    startOfHour.setHours(hour, 0, 0, 0);

    const endOfHour = new Date(desiredDate);
    endOfHour.setHours(hour + 1, 0, 0, 0);


    const dataToProcessFinal = dataToProcess.filter((event) =>
      (myBookingTypes || []).some(
        (val) => parseInt(val.id) === event.bookingTypeId
      )
    );

    // Filter events whose start time falls within this hour range
    const eventsForHour = dataToProcessFinal.filter((event) => {
      const eventStart = new Date(event.time);
      if (!event.isAllDay) {
        return eventStart >= startOfHour && eventStart < endOfHour;
      }
      else {
        return (hour === 0 && event.time === formattedDate) // use hour === 0  to check once for allDay 
      }
    }).map((event) => {
      const startTime = new Date(event.time);
      const bookingType = (myBookingTypes || []).find(
        (val) => parseInt(val.id) === event.bookingTypeId
      );
      if (!bookingType) return null;

      const durationMinutes = bookingType?.length || event.duration || 60; // default to 60 minutes
      const endTime = new Date(startTime.getTime() + durationMinutes * 60000);
      return { startTime, endTime, bookingType, event };
    });

    return eventsForHour;
  };


  return (
    <div>
      {showShortWeekCalendar && (
        <WeekNavigation />
      )}
      <EventScheduler
        events={dataToProcess}
        getEventsForHour={getEventsForHour}
        bookItOrCreateRef={bookItOrCreateRef}
        showTimeSlots={showTimeSlots}
        BookItOrCreate={BookItOrCreate}
        currentDate={currentDate}
      />
    </div>
  );
};

export default DayView;
